// extracted by mini-css-extract-plugin
module.exports = {"rigbook":"rigbook_rigbook__sbzjs"};